"use client"
import { useState, useEffect } from "react"

const Hero = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="w-full flex items-center justify-center py-10 md:py-16 mt-20">
      <div className="w-[90%] rounded-3xl p-8 md:p-16 flex flex-col items-center justify-center text-center border border-[#ccd4d4] bg-[#fcf8ef]">
        {/* Centered Content */}
        <div className="max-w-4xl space-y-6">
          <div className="space-y-4">
            <h1 className="text-[24px] md:text-[40px] font-medium text-gray-900 leading-tight">
              Upskill Your Workforce: 
              <br />
              Corporate Training & Workshops
            </h1>
            <p className="text-base text-gray-700 mx-auto">
             Fuel your team's growth with specialized training programs focused on achieving business goals
            </p>
          </div>
          <button 
            onClick={scrollToContact}
            className="bg-[#33c375] cursor-pointer shadow-[inset_0_0_0_2px_rgba(0,39,38,0.3)] hover:bg-[#6AD384] text-[#012726] font-medium px-6 py-3 rounded-xl stroke-2 flex items-center justify-center mx-auto transition-all"
          >
            Upskill Your Team
          </button>
        </div>
      </div>
    </div>
  )
}

export default Hero